import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Grid, Stack, Typography } from "@mui/material";
import HandshakeTwoToneIcon from "@mui/icons-material/HandshakeTwoTone";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, FormHelperText } from "@financeable-com-au/financeable-ui";
import { useGetLocalAndLenderErrors } from "@/hooks/useRequiredFields/useGetLocalAndLenderErrors";
import { agreementDetail, APPLICATION_SECTIONS_ID, pointDetail } from "../../constants";
import { setValidationRequireFieldError, updateApplicationAgreement, userDetailsSelector } from "../../store/slices/applicationFormSlice";

const IntroducerDeclaration = ({ introducerDeclarationAgree, applicationId, errorField, setErrorField, isDisableEdit }) => {
  const dispatch = useDispatch();

  const { validationRequireFieldError } = useSelector(userDetailsSelector);
  const { agreementError } = validationRequireFieldError;
  const handleCheckbox = () => {
    dispatch(
      updateApplicationAgreement({
        applicationId,
        _id: applicationId,
        introducerDeclarationAgree: !introducerDeclarationAgree,
      }),
    );
  };

  useEffect(() => {
    if (introducerDeclarationAgree === true) {
      setErrorField({
        ...errorField,
        introducerDeclarationAgree: "",
      });
      dispatch(setValidationRequireFieldError({ ...validationRequireFieldError, agreementError: { ...agreementError, introducerDeclarationAgree: "" } }))
    }
  }, [introducerDeclarationAgree]);

  const { getAgreementLocalAndLenderError } = useGetLocalAndLenderErrors();
  const getLocalAndLenderError = ({ fieldName, localFieldName }) =>
    getAgreementLocalAndLenderError({ fieldName, localFieldName, localState: {} });

  return (
    <Grid container style={{ margin: "0 0 40px" }} id={APPLICATION_SECTIONS_ID.INTRODUCER_DECLARATION}>
      <Grid container xs={12} sm={12} md={2}>
        <HandshakeTwoToneIcon style={{ marginRight: "2px" }} />
        <Typography>Introducer Declaration</Typography>
      </Grid>

      <Grid
        xs={12}
        sm={12}
        md={10}
        spacing={2}
        style={{
          padding: "0 0 0 10px",
        }}
      >
        <Stack direction={"row"}>
          <Checkbox
            disabled={isDisableEdit}
            checked={introducerDeclarationAgree}
            onClick={handleCheckbox}
            style={{
              ...getLocalAndLenderError({ fieldName: "introducerDeclarationAgree", localFieldName: "introducerDeclarationAgree" }) && {
                color: "#d32f2f",
              },
            }}
          />
          <Typography
            variant="subtitle2"
            fontWeight={"bold"}
            marginTop={"10px"}
          >
            I agree to the below terms *
          </Typography>
        </Stack>
        {getLocalAndLenderError({ fieldName: "introducerDeclarationAgree", localFieldName: "introducerDeclarationAgree" }) && (
          <Stack ml={2} mb={2}>
            <FormControl error={true}>
              <FormHelperText>
                {getLocalAndLenderError({ fieldName: "introducerDeclarationAgree", localFieldName: "introducerDeclarationAgree" })}
              </FormHelperText>
            </FormControl>
          </Stack>
        )}
        <Stack style={{ margin: "0 0 10px" }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
              <Typography variant="subtitle2" fontWeight={"bold"}>
                By completing and submitting the application on behalf of the applicant(s), you acknowledge that:
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ol style={{ marginLeft: "5px" }}>
                {agreementDetail.map((detailLine, i) => (
                  <li>
                    <Typography>{detailLine}</Typography>
                    {i === agreementDetail.length - 1 ? (
                      <ul style={{ marginLeft: "15px" }}>
                        {pointDetail.map((detailLine) => (
                          <li>
                            <Typography>{detailLine}</Typography>
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </li>
                ))}
              </ol>
            </AccordionDetails>
          </Accordion>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default IntroducerDeclaration;
